import ServiceGraphQL from 'src/service/gql-service';
import { removeBill } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const RemoveBill = (id) => {
  const params = {
    query: removeBill.QUERY,
    variables: {
      filter: {
        _id: id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
